var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('receipt-order',{ref:"orders",attrs:{"order-status":_vm.orderStatus,"owners":_vm.owners,"refundable":_vm.refundable},on:{"clearDetails":_vm.clearDetails,"showDetails":_vm.showDetails}}),_c('receipt-detail',{ref:"details",attrs:{"refundable":_vm.refundable},on:{"receive":_vm.receive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }